<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { EmblaCarouselType } from "embla-carousel";
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import { Locale } from "@core/schema/Locale.js";
	import WholesalePartnerCard from "./WholesalePartnerCard.svelte";
	import type { WholesalePartner } from "./WholesalePartnerCardProps.js";
	import translations from "./WholesalePartners.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	let canNext = $state(false);
	let canPrev = $state(false);

	let api = $state<EmblaCarouselType>();

	const partnes: WholesalePartner[] = [
		{
			author: translate("reviewMatildaAuthor"),
			cite: translate("reviewMatildaCite"),
		},
		{
			author: translate("reviewKiosekAuthor"),
			cite: translate("reviewKiosekCite"),
		},
		{
			author: translate("reviewKofeBrakAuthor"),
			cite: translate("reviewKofeBrakCite"),
		},
		{
			author: translate("reviewShothouseAuthor"),
			cite: translate("reviewShothouseCite"),
		},
		{
			author: translate("reviewNebeskaAuthor"),
			cite: translate("reviewNebeskaCite"),
		},
		{
			lang: Locale.en,
			author: "MUTO nl[[]] Madrid",
			cite: "Working with Father’s Coffee Roastery always feels warm and personal. We really appreciate the closeness they share and the genuine family vibe they radiate — it comes through in everything they do. nl[[]] Their coffee is consistently excellent, and every delivery feels special, from the elegant packaging to the thoughtful seasonal touches. We highly recommend ordering the Inzá, Cauca (Colombia) for espresso and stocking up on the Alex Rayo Geisha whenever it’s available — a true gem for filter coffee!",
		},
		{
			lang: Locale.en,
			author: "Goldhahn & Sampson nl[[]] Berlin",
			cite: "Our coffee team at Goldhahn & Sampson in Berlin is always curious to discover outstanding smaller roasteries from all over Europe. We were lucky to find Father’s and their lovely team, who are absolutely unique in their openness and creativity. nl[[]] From perfectly balanced classics to roasts branching far into funky/positively weird territory, and even their seasonal packaging designs, our customers and we are huge fans. We have truly found long-term partners!",
		},
		{
			lang: Locale.en,
			author: "Batch Baby nl[[]] London",
			cite: "Father’s is always one of our favorite roasters to stock. Always really high quality and super consistent on the coffee front; we always know we’re going to get great coffee. We also like using Father’s because, like us, they’re really creative and we always get something new or different from them. Couldn't recommend them more highly!!!",
		},
	];
</script>

<div class="flex justify-between mb-9 md:mb-15 items-center">
	<div class="text-fcrdarkgray heading-2">
		<Heading level={2} text={translate("ourPartnersTitle")} />
	</div>
	<div class="hidden sm:flex gap-2 text-fcrdarkgray">
		<button
			type="button"
			class={[
				"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
				"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
				"[&:not(:disabled):hover]:border-fcrdarkgray",
			]}
			onclick={(): void => {
				api?.scrollPrev();
			}}
			disabled={!canPrev}
		>
			<Icon icon={arrowIcon} class="size-4.5 rotate-180" />
		</button>
		<button
			type="button"
			class={[
				"size-16 flex items-center bg-white justify-center border-fcrlightgray-300 disabled:opacity-50 border rounded-full",
				"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
				"[&:not(:disabled):hover]:border-fcrdarkgray",
			]}
			onclick={(): void => {
				api?.scrollNext();
			}}
			disabled={!canNext}
		>
			<Icon icon={arrowIcon} class="size-4.5 " />
		</button>
	</div>
</div>

<Carousel
	bind:canNext
	bind:canPrev
	bind:api
	options={{ dragFree: true }}
	items={partnes}
	class="full-width"
	itemsContainerClass="gap-8"
	alignWithGridContainer
>
	{#snippet item(partner)}
		<WholesalePartnerCard {partner} />
	{/snippet}
</Carousel>
